var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrap-start-header search pl16 pr16"},[_c('button',{staticClass:"btn-header back",on:{"click":function($event){return _vm.BackEvt()}}}),_c('div',{staticClass:"title-header"},[_vm._v(_vm._s(_vm.$t('event_search')))])]),_c('event-list-component',{attrs:{"event-type":'eventSearch'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }